// extracted by mini-css-extract-plugin
export default {"brandPromo":"hG-z","carousel":"iG-z"};